import * as React from 'react'
import * as SliderPrimitive from '@radix-ui/react-slider'
import { cn } from '../../utils/cn'
import { TooltipTrigger } from './Tooltip'

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      'relative flex w-full touch-none select-none items-center',
      className,
    )}
    {...props}
  >
    <SliderPrimitive.Track className='relative h-2.5 w-full grow overflow-hidden rounded-full bg-[#E6F1FF]'>
      <SliderPrimitive.Range className='absolute h-full bg-primaryBlue' />
    </SliderPrimitive.Track>

    <TooltipTrigger asChild>
      <SliderPrimitive.Thumb className='border-4 shadow-md border-white block h-6 w-6 rounded-full  bg-primaryBlue transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white disabled:pointer-events-none disabled:opacity-50' />
    </TooltipTrigger>
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
